// extracted by mini-css-extract-plugin
export default {"body":"tab_fishing_reports__body--Hdd9","fishingReportsList":"tab_fishing_reports__fishingReportsList--ap53"};